/* Atomic native variant selection for the unpublished preview theme. */
(() => {
  if (window.EHAtomicNativeVariantPicker) return;
  window.EHAtomicNativeVariantPicker = true;

  const same = (left, right) => String(left ?? '') === String(right ?? '');
  const available = (variant) => variant?.available === true;
  const price = (variant) => {
    const value = Number.parseFloat(variant?.price);
    return Number.isFinite(value) ? value : Number.POSITIVE_INFINITY;
  };
  const cheapest = (variants) => variants.reduce((best, variant) => (
    available(variant) && (!best || price(variant) < price(best)) ? variant : best
  ), null);
  const groups = (picker) => [...picker.querySelectorAll('.product-form__input')]
    .filter((group) => !group.classList.contains('product-form__input--quantity-breaks'));
  const nameOf = (group) => group.querySelector('select, input')?.name
    ?.match(/^options\[(.+)\]$/i)?.[1]
    || group.querySelector('legend, .form__label')?.textContent?.trim() || '';
  const isColor = (name) => /^colou?r$/i.test(name.trim());
  const controls = (group) => group.querySelector('select')
    ? [...group.querySelector('select').options]
    : [...group.querySelectorAll('input[type="radio"]')];
  const valueOf = (group) => group.querySelector('select')?.value
    ?? group.querySelector('input[type="radio"]:checked')?.value ?? '';
  const readVariants = (picker) => {
    try { return JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent || '[]'); }
    catch (error) { console.error('Atomic variant data could not be read.', error); return []; }
  };
  const setRadioVisibility = (control, visible) => {
    control.disabled = !visible;
    control.classList.toggle('disabled', !visible);
    const label = control.id && control.closest('.product-form__input')
      ?.querySelector(`label[for="${CSS.escape(control.id)}"]`);
    if (label) { label.hidden = !visible; label.setAttribute('aria-hidden', String(!visible)); }
  };
  const refreshAvailability = (picker, variants, pickerGroups, values) => {
    const colorIndex = pickerGroups.findIndex((group) => isColor(nameOf(group)));
    pickerGroups.forEach((group, index) => controls(group).forEach((control) => {
      const visible = index === colorIndex
        ? variants.some((variant) => available(variant) && same(variant.options?.[index], control.value))
        : variants.some((variant) => available(variant) && same(variant.options?.[index], control.value)
          && variant.options?.every((value, position) => position === index || same(value, values[position])));
      if (control.tagName === 'OPTION') {
        control.textContent = control.value;
        control.disabled = !visible;
        control.hidden = !visible;
      } else setRadioVisibility(control, visible);
    }));
  };
  const setNativeValues = (pickerGroups, variant, colorIndex) => {
    variant.options?.forEach((value, index) => {
      if (index === colorIndex) return;
      const group = pickerGroups[index];
      const select = group?.querySelector('select');
      if (select) select.value = value;
      else group?.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = same(input.value, value); });
    });
  };
  const initialize = (picker) => {
    const pickerGroups = groups(picker);
    const variants = readVariants(picker);
    if (pickerGroups.length && variants.length) {
      refreshAvailability(picker, variants, pickerGroups, pickerGroups.map(valueOf));
    }
  };
  const handleChange = (event) => {
    const picker = event.target.closest?.('variant-selects');
    if (!picker || (event.target.tagName !== 'SELECT' && event.target.type !== 'radio')) return;
    const pickerGroups = groups(picker);
    const colorIndex = pickerGroups.findIndex((group) => isColor(nameOf(group)));
    const changedIndex = pickerGroups.indexOf(event.target.closest('.product-form__input'));
    const variants = readVariants(picker);
    const values = pickerGroups.map(valueOf);
    if (changedIndex === colorIndex) {
      const chosen = cheapest(variants.filter((variant) => available(variant)
        && same(variant.options?.[colorIndex], values[colorIndex])));
      if (chosen) setNativeValues(pickerGroups, chosen, colorIndex);
    }
    refreshAvailability(picker, variants, pickerGroups, pickerGroups.map(valueOf));
    // Do not cancel, stop, redispatch, or navigate: the original event continues.
  };

  document.addEventListener('change', handleChange, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('variant-selects').forEach(initialize), { once: true });
  } else document.querySelectorAll('variant-selects').forEach(initialize);
})();
